<ion-app>
  <ion-router-outlet [swipeGesture]="!isLocked" />
</ion-app>
